module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.value.length === 0) ? _c('div', {
    staticClass: "empty-container"
  }, [_c('div', {
    on: {
      "click": _vm.handleToggleCollapse
    }
  }, [_vm._v("Expand to add choices for this question")])]) : _vm._e(), _vm._v(" "), _c('draggable', {
    staticClass: "choice-container",
    attrs: {
      "group": "choices",
      "draggable": ".draggable"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleToggleCollapse($event)
      }
    },
    model: {
      value: (_vm.computedValue),
      callback: function($$v) {
        _vm.computedValue = $$v
      },
      expression: "computedValue"
    }
  }, _vm._l((_vm.computedValue), function(choice) {
    return _c('div', {
      key: choice.id,
      staticClass: "choice",
      class: {
        draggable: _vm.isEditable
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_vm._v(_vm._s(choice.title))])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e50f0d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/editors/select/SelectEditorCollapsed.vue
// module id = 3276
// module chunks = 3